import {
	HEADER_OFFSET_CONFIG,
	TRANSITION_CONFIG
} from '~/composables/useDragToBottom/constants';

export function usePropertiesListingHeader() {
	// Única fonte de verdade para headerDragOffsetY.
	// Compartilhado entre layout, página e useBottomSheet via useState.
	const headerDragOffsetY = useState<number>(
		'header-drag-offset-y',
		() => HEADER_OFFSET_CONFIG.MIN_OFFSET
	);

	const isBottomSheetDragging = useState<boolean>(
		'is-bottom-sheet-dragging',
		() => false
	);

	// isHeaderHidden e false no SSR e no 1o render do client (headerDragOffsetY
	// comeca em MIN_OFFSET), entao ambos os lados renderizam igual — sem mismatch
	// de hydration nem salto de layout.
	const isHeaderHidden = computed(
		() => headerDragOffsetY.value >= HEADER_OFFSET_CONFIG.MAX_OFFSET
	);

	// Reexibe a navbar. Necessario na navegacao SRP->SRP: a pagina tem `key`
	// estatica (definePageMeta), entao a instancia e REUSADA — onMounted/
	// onUnmounted (e o reset do layout) nao re-disparam, e o offset oculto
	// vazaria para a proxima listagem. A pagina chama isto no watch da rota.
	function resetHeaderToVisible(): void {
		headerDragOffsetY.value = HEADER_OFFSET_CONFIG.MIN_OFFSET;
	}

	// Estilo de transform compartilhado por navbar (layout) e barra de filtros:
	// segue o offset do drag, sem transicao durante o arrasto do sheet (1:1) e
	// com transicao suave fora dele. Cada consumidor aplica seus proprios guards.
	const headerTransformStyle = computed(() => {
		const offset = Math.min(
			Math.max(headerDragOffsetY.value, HEADER_OFFSET_CONFIG.MIN_OFFSET),
			HEADER_OFFSET_CONFIG.MAX_OFFSET
		);
		return {
			transform: `translateY(-${offset}px)`,
			transition: isBottomSheetDragging.value
				? 'none'
				: `transform ${TRANSITION_CONFIG.DURATION} ${TRANSITION_CONFIG.TIMING_FUNCTION}`
		};
	});

	return {
		headerDragOffsetY,
		isBottomSheetDragging,
		isHeaderHidden,
		resetHeaderToVisible,
		headerTransformStyle
	};
}
